import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faAt } from "@fortawesome/free-solid-svg-icons";
import { aboutGroups } from "./navdata.js";

function AboutImageLink({ item, onNavigate }) {
  return (
    <Link className="aboutLink" to={item.link} onClick={onNavigate}>
      <img
        className="aboutLinkImage"
        src={item.image}
        alt=""
        aria-hidden="true"
      />
      <span className="aboutLinkText">
        <span className="aboutLinkTitle">{item.text}</span>
        {item.sub && <span className="aboutLinkSub">{item.sub}</span>}
      </span>
    </Link>
  );
}

function AboutPlainLink({ item, onNavigate }) {
  const body = (
    <>
      <span className="aboutPlainText">{item.text}</span>
      <FontAwesomeIcon
        icon={faArrowRight}
        className="aboutPlainArrow"
        aria-hidden="true"
      />
    </>
  );
  if (item.external) {
    return (
      <a
        className="aboutPlainLink"
        href={item.link}
        target="_blank"
        rel="noreferrer"
        onClick={onNavigate}
      >
        {body}
      </a>
    );
  }
  return (
    <Link className="aboutPlainLink" to={item.link} onClick={onNavigate}>
      {body}
    </Link>
  );
}

/**
 * Desktop "About Us" panel: 3 columns. An image-led link group for the data
 * guides, a plain arrow-link group for the org pages, and a called-out
 * Contact Us card with an @ icon.
 *
 * @param props.onNavigate Called when any link is activated
 * @return JSX element
 */
export function AboutMenu({ onNavigate }) {
  const { aboutData, aboutUs, contact } = aboutGroups;
  return (
    <div className="aboutMenu">
      <div className="aboutColumn">
        <div className="aboutGroupLabel">{aboutData.label}</div>
        {aboutData.links.map((item) => (
          <AboutImageLink key={item.link} item={item} onNavigate={onNavigate} />
        ))}
      </div>

      <div className="aboutColumn">
        <div className="aboutGroupLabel">{aboutUs.label}</div>
        {aboutUs.links.map((item) => (
          <AboutPlainLink key={item.link} item={item} onNavigate={onNavigate} />
        ))}
      </div>

      <div className="aboutColumn">
        <div className="aboutGroupLabel">{contact.label}</div>
        <div className="contactCard">
          <div className="contactCardTop">
            <a
              className="contactCardIconLink"
              href={`mailto:${contact.email}`}
              onClick={onNavigate}
              aria-hidden="true"
              tabIndex={-1}
            >
              <FontAwesomeIcon
                icon={faAt}
                className="contactCardIcon"
                aria-hidden="true"
              />
            </a>
            <div className="contactCardText">
              <a
                className="contactCardTitle"
                href={`mailto:${contact.email}`}
                onClick={onNavigate}
              >
                {contact.title}
              </a>
              <div className="contactCardBlurb">{contact.blurb}</div>
              <a
                className="contactCardButton"
                href={`mailto:${contact.email}`}
                onClick={onNavigate}
              >
                {contact.buttonText}&nbsp;&rarr;
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
